/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React, { PropsWithChildren } from 'react';
import AntdAlert, { AlertProps as AntdAlertProps } from 'antd/lib/alert';
import Icons from 'src/components/Icons';
import { theme } from 'src/themeSchema';

export type AlertProps = PropsWithChildren<
  AntdAlertProps & { roomBelow?: boolean }
>;

export default function Alert(props: AlertProps) {
  const {
    type = 'info',
    // description,
    showIcon = true,
    closable = true,
    roomBelow = false,
    children,
  } = props;

  // const theme = useTheme();
  const { gridUnit } = theme;
  // const { alert, error, info, success } = colors;

  let AlertIcon = Icons.InfoSolid;
  if (type === 'error') {
    AlertIcon = Icons.ErrorSolid;
  } else if (type === 'warning') {
    AlertIcon = Icons.AlertSolid;
  } else if (type === 'success') {
    AlertIcon = Icons.CircleCheckSolid;
  }

  return (
    <AntdAlert
      role="alert"
      showIcon={showIcon}
      icon={<AlertIcon aria-label={`${type} icon`} />}
      closeText={closable && <Icons.XSmall aria-label="close icon" />}
      css={{
        marginBottom: roomBelow ? gridUnit * 4 : 0,
        padding: `${gridUnit * 2}px ${gridUnit * 3}px`,
        alignItems: 'flex-start',
        borderRadius:'4px',
        backgroundColor: `rgba(32, 122, 239, 0.1)`,
        '& .ant-alert-icon': {
          marginRight: gridUnit * 2,
        },
        '& .ant-alert-message': {
          color: "#172b40 !important",
          fontSize: "13px !important",
          fontWeight: "bold",
          lineHeight:'16px !important'
        },
        '& .ant-alert-description': {
          color: "#172b40 !important",
          fontSize: "13px !important",
          fontWeight: "normal",
          lineHeight:'16px !important'
        },
        border:'none !important',
      }}
      {...props}
    >
      {children}
    </AntdAlert>
  );
}
